import * as Yup from "yup";
import { bankStatementRequiredMessage } from "./shared";


export const bankStatementSchema = Yup.object({
  bankStatementReferralCode: Yup.string()
    .when("bankStatementReferralCodeSkip", {
      is: false,
      then: () => Yup.string().required(bankStatementRequiredMessage)
    })
});
